import {addToCart} from 'cart';
import 'tracking-events';
import 'utils';
import 'component/modal-trigger';

window.theme.cart = window.theme.cart || {};

window.theme.cart.addToCart = addToCart;

/** ********************************************************************************** */
/** ********************************DO NOT EDIT BELOW********************************* */
/** ********************************************************************************** */

const logShoplabBranding = () => {
  const brand1 = [
    'background: #000639',
    'padding: 20px',
    'color: #fff',
    'font-size: 1.9em',
    'font-family: "Helvetica Neue", Helvetica, Arial, sans-serif',
    'font-weight: bold',
    'width: 400px',
  ].join(';');

  const brand2 = [
    'background: #fff',
    'padding: 0px',
    'color: #000639',
    'font-size: 1.1em',
    'line-height: 1.2em',
    'font-family: "Helvetica Neue", Helvetica, Arial, sans-serif',
    'font-weight: bold',
    'text-decoration: none',
    'width: 400px',
  ].join(';');

  // eslint-disable-next-line no-console
  console.log('%c shoplab', brand1);
  // eslint-disable-next-line no-console
  console.log('%c Shopify Experts \n www.shoplab.cc', brand2);
};

/**
 * Custom DOMready function
 * @param {*} callback
 */
const labDOMready = (callback) => {
  if (document.readyState !== 'loading') callback();
  else document.addEventListener('DOMContentLoaded', callback);
};

/**
 * Use this event listener to run your JS after the DOM is ready
 */
labDOMready(() => {
  document.dispatchEvent(new CustomEvent('page:loaded'));

  logShoplabBranding();
});
